// LanguageSwitcher.js - Alternar entre português e inglês
//
// Fica no cabeçalho do menu, ao lado do utilizador e da instalação: é o
// sítio por onde toda a gente passa, e não obriga a caçar a opção dentro
// das definições.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IDIOMAS, mudarIdioma } from './i18n';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const atual = i18n.resolvedLanguage || i18n.language;

  return (
    <div className="lang-switch" role="group" aria-label="Idioma">
      {IDIOMAS.map((idioma) => (
        <button
          key={idioma.code}
          type="button"
          className={`lang-btn ${atual === idioma.code ? 'active' : ''}`}
          onClick={() => mudarIdioma(idioma.code)}
          aria-pressed={atual === idioma.code}
          title={idioma.nome}
        >
          {idioma.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
